import ApiGo from "./ApiGo";
import { SET_LOGIN_STATUS } from "../stores/reducer_loginStatus";
import { loginStore } from "../comm_stores";
import ApiGo_AuditTrail from "./ApiGo_AuditTrail";
import i18n from "../i18n";

export default class Account {
  constructor() {
    this.email = localStorage.getItem("currentAccount")
    this.account = JSON.parse(localStorage.getItem(this.email))
    this.pwd = localStorage.getItem(this.account)
    this.role = localStorage.getItem("currentRole")
    this.type = ''
    this.os = ''
    this.loginStatus = false
    this.applicationStatus = false
    this.local_token = 0
    this.token = 0
    this.uid = 0
    this.unit_id = 0
    this.institution = 0
    this.i18n = 'zh-tw'
    this.isMobile = false
  }

  async verify(_flag = true) {
    this.applicationStatus = _flag
    let _return = 'denied'
    this.getCurrentAccount()
    this.get_user_devices()
    if (this.email === null && this.pwd === null && loginStore.getState().status === "denied") {
      loginStore.dispatch(SET_LOGIN_STATUS({
        status: 'denied',
        responseState: 404
      }))
      return
    }
    let res
    try {
      res = await ApiGo.verifyUser(this.email, _flag, this.type, this.os)
      if (_flag === 0) return
      if (res.role === "superdoctor" || res.role === "doctor" || res.role === "admin" || res.role === "user") {
        loginStore.dispatch(SET_LOGIN_STATUS({
          status: res.role,
          responseState: 200
        }))
        this.role = res.role
      }
      else {
        loginStore.dispatch(SET_LOGIN_STATUS({
          status: 'denied',
          responseState: 404
        }))
        this.role = res.role
      }
      return _return
    }
    catch { return _return }
  }

  async login(_acc, _pwd) {
    this.storeToken(0, 0, 0, 0)    // 為了繞過 backend unit_id、institution 數字限制。
    this.getCurrentAccount()
    this.get_user_devices()
    ApiGo.login(_acc, _pwd, this.type, this.os)
      .then(res => {
        if (res.activation === 0) {
          loginStore.dispatch(SET_LOGIN_STATUS({
            status: 'denied',
            responseState: 404
          }))
        }
        else {
          this.storeToken(res.access_token, res.id, parseInt(res.institution), parseInt(res.unit_id))
          this.storeAccount(res, _pwd)
          loginStore.dispatch(SET_LOGIN_STATUS({
            status: res.role,
            responseState: 200
          }))

          let audit_trail_event = "AUDIT_TRAIL.EVENTS." + 'LOGIN';
          let msg = ''
          let action = i18n.t(audit_trail_event, { lng: "zh-TW" }) +
            (msg ? (" " + msg + " ") : " ") +
            // i18n.t('GLOBAL.STATUS.SUCCESS', { lng: "ja-JP" });
            i18n.t('GLOBAL.STATUS.SUCCESS', { lng: "zh-TW" });
          ApiGo_AuditTrail.postAuditTrail(action, 'LOGIN');
        }
      })
      .catch(err => {
        if (err.status === 422 || err.status === 404) {
          loginStore.dispatch(SET_LOGIN_STATUS({
            status: 'denied',
            responseState: 422
          }))
        }
        else {
          loginStore.dispatch(SET_LOGIN_STATUS({
            status: 'denied',
            responseState: 500
          }))
        }
      })
    return 'end'
  }
  async logout(_flag = true) {
    this.getCurrentAccount()
    this.get_user_devices()
    if (this.email !== null) {
      // await this.verify(0)
      await ApiGo.logout(this.email, this.type, this.os)
      this.clearStorage()
      loginStore.dispatch(SET_LOGIN_STATUS({
        status: 'denied',
        responseState: 0
      }))
    }
  }

  getCurrentAccount() {
    let _return = 'denied'
    if (this.email === undefined || this.email === null) return _return
    if (this.account.role === 'superdoctor' || this.account.role === "doctor") _return = 'doctor'
    else if (this.account.role === "admin") _return = 'admin'
    return _return
  }

  // 抓系統資訊
  get_user_devices() {
    let _temp = navigator.userAgent.split("(")[1]
    let _temp2 = _temp.split(")")[0]
    let _temp3 = _temp2.replaceAll(" ", "")
    let userAgent = _temp3.split(";")
    let _type = userAgent[1].replace("(", '')
    if (_type === "linux") {                  // android
      this.type = userAgent[2]
      this.os = userAgent[1]
    } else if (_type === "iPhone") {             // iPhone
      this.type = _type
      this.os = userAgent[1].split(" ")[2] + userAgent[1].split(" ")[3]
    } else if (_type === "Macintosh") {          // Mac
      this.type = _type
      this.os = userAgent[1].replace("(", '')
    } else {
      this.type = userAgent[0]
      this.os = userAgent[1]
    }
    localStorage.setItem("Device_OS",
      JSON.stringify({
        "os": this.os,
        "type": this.type
      }))
    return [this.type, this.os]
  }
  storeAccount(user_info, pwd) {
    user_info.created_at = ''
    user_info.updated_at = ''
    user_info.access_token = ''
    let js = JSON.stringify(user_info);
    let _name = (this.i18n === "en") ? user_info.first_name + " " + user_info.last_name : user_info.last_name + user_info.first_name
    localStorage.setItem("currentAccount", user_info.email)
    localStorage.setItem("currentUser", _name)
    localStorage.setItem("currentRole", user_info.role)
    localStorage.setItem("currentInstitution", user_info.institution)

    localStorage.setItem(user_info.email, js)
    // localStorage.setItem(js, pwd)
  }
  clearStorage() {
    let _email = localStorage.getItem("currentAccount")
    let _info = localStorage.getItem(_email)
    localStorage.removeItem(_email)
    localStorage.removeItem(_info)
    localStorage.removeItem("currentAccount")
    localStorage.removeItem("currentUser")
  }
  getLocakToken() {
    // this.local_token = localStorage.getItem("TOKEN") || "currently no token storage"
    // this.uid = localStorage.getItem("UID") || "currently no uid storage"
    this.local_token = localStorage.getItem("TOKEN") || 0
    this.uid = localStorage.getItem("UID") || 0
    this.institution = localStorage.getItem("institution")
    this.unit_id = localStorage.getItem("unit_id")
    return { token: this.local_token, uid: this.uid }
    // return {token: this.local_token, uid: this.uid, 'institution-id':this.institution, 'unit-id':this.unit_id}
  }
  storeToken(_t, _id, _institution = 0, _unit = 0) {
    localStorage.setItem('TOKEN', _t)
    localStorage.setItem('UID', _id)
    localStorage.setItem("institution", _institution)
    localStorage.setItem("unit_id", _unit)
  }
  static isMobileOrTablet() {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }
  static isMobile() {
    return window.innerWidth < 510
  }
  static isTablet() {
    return window.innerWidth > 510 && window.innerWidth < 1100
  }
  static isLandscape() {
    return window.innerHeight < window.innerWidth
  }
  static isAutoLoginViaUrl() {
    const params = new URLSearchParams(window.location.search);
    return !!(params.get('account') && params.get('password'));
  }
  static getUrlLoginParams() {
    const params = new URLSearchParams(window.location.search);
    return { account: params.get('account'), password: params.get('password') };
  }
}